<template>
  <b-modal id="modal-jaleklinico-imagem" dialog-class="modal-imagem" hide-header hide-footer size="xl" :no-enforce-focus="true">
    <img :src="obterUrlS3(imagem)" width="150px"/><br>
  </b-modal>
</template>

<script>
import UrlUtils from '@/core/utils/url-utils'

export default {
  name: 'ModalJaleklinicoImagem',
  inheritAttrs: false,
  props: {
    caso_id: Number,
    imagem: String,
    pergunta_id: Number
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-jaleklinico-imagem')
    },
    obterUrlS3: function (arquivo) {
      arquivo = this.caso_id + '_' + this.pergunta_id + '_' + arquivo
      return UrlUtils.obterUrlS3(arquivo)
    }
  }
}
</script>

<style scoped>

</style>
